import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/cbs";

export const fragments = {
	SensorAlert: `
		fragment SensorAlert on SensorAlert {
			id
			updated_at
			limit_value
			current_value
			message
			device {
				...DeviceType
			}
			sensor {
				...Sensor
			}
		}
	`,
	Sensor: `
		fragment Sensor on Sensor {
			id
			name
			unit
			type
			is_active
			limit_value
			warning_threshold
			alert_threshold
		}
	`,
	DeviceType: `
		fragment DeviceType on DeviceType {
			id
			name
			code
			status
			category {
				id
				name
				properties
			}
		}
	`,
};

const GET_SENSOR_ALERTS = `
	sensor_alerts (limit: $limit, page: $page, is_active: $is_active) {
		data {
			...SensorAlert
		}
		total
	}
`;

export default {
	init() { },

	fetchSensorAlerts(payload) {
		const queryOptions = {
			query: gql`query SensorAlerts ($limit: Int!, $page: Int!, $is_active: Int!) {
					${GET_SENSOR_ALERTS}
				}
				${fragments.SensorAlert}
				${fragments.Sensor}
				${fragments.DeviceType}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				is_active: payload.is_active || 1,
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				sensorAlerts: response.data.sensor_alerts.data
			}
		});
	},
};
